import OrigianlJoi from "joi";

type ObjectIdSchema = OrigianlJoi.AnySchema;

export interface ExtendedJoi extends OrigianlJoi.Root {
	objectId(): ObjectIdSchema;
}

export type ObjectId = string;

const Joi: ExtendedJoi = OrigianlJoi.extend({
	type: "objectId",
	messages: {
		"objectId.base":
			"needs to be a string of 12 bytes or a string of 24 hex characters",
	},
	validate(value, helpers) {
		return {
			value,
			errors: null,
		};
	},
})
	.extend({
		type: "object",
		base: OrigianlJoi.object(),
		coerce: {
			from: "string",
			method(value, helpers) {
				if (value[0] !== "{" && !/^\s*\{/.test(value)) {
					return;
				}

				try {
					return { value: JSON.parse(value) };
				} catch (ignoreErr) {}
			},
		},
	})
	.extend({
		type: "array",
		base: OrigianlJoi.array(),
		coerce: {
			from: "string",
			method(value, helpers) {
				if (
					typeof value !== "string" ||
					(value[0] !== "[" && !/^\s*\[/.test(value))
				) {
					return;
				}

				try {
					return { value: JSON.parse(value) };
				} catch (ignoreErr) {}
			},
		},
	});

export default Joi;
